import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  ArrowLeftIcon2,
  ArrowRightIcon2,
  HeartFillIcon,
  HeartIcon,
  ShareIcon,
} from "assets/icons";
import Layout from "components/layout";
import { AddressCard, ExploreCard, SpinLoader } from "components";
import { Explore, Location, Reviews } from "sections";
import AvailableBuses from "./availableBuses";
import { getCityDetail } from "../../redux/axios";

export default function TopCities() {
  const { id } = useParams();
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(null);

  const overviews = [
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  ];

  const exploreLikeList = [
    {
      id: 1,
      image: "/images/explore-8.png",
      title: "Malaysia's Batu Caves, where spirituality meets adventure",
      price: "150.00",
    },
    {
      id: 2,
      image: "/images/explore-9.png",
      title: "Most beautiful relaxing island Semporna",
      price: "950.00",
    },
    {
      id: 3,
      image: "/images/explore-10.png",
      title: "Genting Highland Day Tour - An exciting and fun experiences",
      price: "350.00",
    },
  ];

  useEffect(() => {
    if (id) {
      getDetails();
    }
  }, [id]);

  const getDetails = async () => {
    const res = await getCityDetail(id, setLoading);
    setDetails(res?.data);
  };

  const headActions = () => (
    <div className="flex items-center gap-2 lg:gap-3">
      <button
        onClick={() => setIsFavorite(!isFavorite)}
        className="h-8 lg:h-12 w-8 lg:w-12 rounded-[4px] lg:border-[1px] border-primary-700 flex items-center justify-center"
      >
        <span
          className={`h-[18px] w-[18px] ${
            isFavorite ? "text-primary-700" : ""
          }`}
        >
          {isFavorite ? <HeartFillIcon /> : <HeartIcon />}
        </span>
      </button>
      <button className="h-8 lg:h-12 w-8 lg:w-12 rounded-[4px] lg:border-[1px] border-primary-700 flex items-center justify-center">
        <ShareIcon />
      </button>
    </div>
  );

  console.log("city details...", details);

  if (loading) {
    return (
      <Layout showMobileHeader={false} showBottomTab={false}>
        <div className="w-full flex justify-center">
          <div className="w-full max-w-8xl margins flex flex-col items-center justify-center py-[100px]">
            <SpinLoader />
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout showMobileHeader={false} showBottomTab={false}>
      <div className="w-full flex justify-center">
        <div className="w-full max-w-8xl margins">
          <div className="mt-10 mb-8 hidden lg:flex items-center gap-2">
            <div className="text-sm text-primary-700 font-semibold">Home</div>
            <ArrowRightIcon2 />
            <div className="text-sm text-[#112211] font-semibold">
              {details?.poi[0]?.title}
            </div>
          </div>

          <div className="w-full flex lg:hidden items-center py-5">
            <Link className="flex-1 flex items-center gap-2 text-sm text-black font-semibold">
              <span className="h-3 w-3">
                <ArrowLeftIcon2 />
              </span>
              Back
            </Link>
            {headActions()}
          </div>

          <div
            className="bgImage rounded-[30px] !h-[300px] md:!h-[450px] mb-4 flex lg:hidden"
            style={{
              backgroundImage: `url(${process.env.REACT_APP_BASE_URL}/${details?.poi[0]?.images[0]})`,
            }}
          />

          <div className="w-full flex items-center lg:items-start justify-between gap-3 mb-4 lg:mb-10">
            <div className="flex flex-col max-w-[600px]">
              <div className="text-[20px] lg:text-[32px] leading-7 lg:leading-10 text-primary-[#263238] font-semibold mb-4 lg:mb-6">
                {details?.poi[0]?.title}
              </div>
              {details?.city_tags?.length ? (
                <div className="flex items-center gap-4 lg:gap-5">
                  {details.city_tags.map((tag, index) => (
                    <div
                      key={index}
                      className="text-sm lg:text-base font-medium bg-[#FFD7D180] p-1"
                    >
                      #{tag}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
            <div className="flex flex-col min-w-fit">
              <div className="min-w-fit text-sm lg:text-lg text-medium text-primary-700 mb-4">
                {details?.reviews?.length} Reviews
              </div>
              <span className="hidden lg:flex items-center">
                {headActions()}
              </span>
            </div>
          </div>

          <div className="w-full flex items-center lg:hidden">
            <AddressCard />
          </div>

          <div className="hidden lg:grid lg:grid-cols-5 gap-2 overflow-hidden rounded-[24px] mb-16">
            <div className="lg:col-span-3">
              <div
                className="bgImage !h-[550px]"
                style={{
                  backgroundImage: `url(${process.env.REACT_APP_BASE_URL}/${details?.poi[0]?.images[0]})`,
                }}
              />
            </div>
            <div
              className={`col-span-2 hidden lg:grid gap-2 ${
                details?.poi[0]?.images?.length === 2
                  ? "grid-cols-1"
                  : "grid-cols-2"
              }`}
            >
              {details?.poi[0]?.images.slice(1).map((image, index) => (
                <div
                  key={index}
                  className={`${
                    details?.poi[0]?.images?.length === 2
                      ? "h-full"
                      : "h-[271px]"
                  }`}
                >
                  <div
                    className="bgImage"
                    style={{
                      backgroundImage: `url(${process.env.REACT_APP_BASE_URL}/${image})`,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="w-full flex flex-col bg-white p-6 md:p-8">
            <div className="text-base md:text-[20px] leading-6 text-[#112211] font-semibold mb-4">
              Overview
            </div>
            <div className="w-full flex flex-col gap-2.5 mb-8">
              {overviews.map((item, index) => (
                <div key={index} className="flex items-start gap-2">
                  <div className="h-1 min-w-1 mt-2 bg-[#112211]/70 rounded-full" />
                  <div className="text-sm sm:text-base text-[#112211]/70 leading-5">
                    {item}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full h-[1px] md:bg-[#112211]/25 my-3 md:my-16" />
          <AvailableBuses routes={details?.routes} />
          <div className="w-full h-[1px] md:bg-[#112211]/25 my-3 md:my-16" />
          <Reviews reviews={details?.reviews} />

          {details?.reviews?.length ? (
            <div className="w-full h-[1px] bg-[#112211]/25 my-16 hidden lg:block" />
          ) : null}

          <div className="hidden lg:block">
            <Location />
          </div>

          <div className="w-full h-[1px] bg-[#112211]/25 my-16 hidden lg:block" />

          <Explore />

          <div className="w-full mt-8 lg:mt-12 mb-10 lg:mb-24">
            <div className="text-base md:text-[32px] lg:leading-8 font-semibold text-black mb-3">
              You may also like
            </div>
            <div className="text-base text-[#112211] mb-10 hidden lg:block">
              Lorem ipsum is a placeholder text commonly used to demonstrate.
            </div>
            <div className="w-full flex">
              <Swiper
                slidesPerView={1.5}
                spaceBetween={18}
                style={{ width: "100%" }}
                breakpoints={{
                  380: {
                    slidesPerView: 1.5,
                  },
                  420: {
                    slidesPerView: 2.2,
                  },
                  980: {
                    slidesPerView: 3,
                  },
                }}
              >
                {exploreLikeList.map((item, index) => (
                  <SwiperSlide key={index}>
                    <ExploreCard key={index} data={item} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
